/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteProductCategoryCtrl',["$scope","$rootScope","$routeParams","ProductCategoryData", function($scope,$rootScope,$routeParams,ProductCategoryData)
    {
        $scope.dd = {
            currentCategoryId :  parseInt($routeParams.categoryId)
        }
        $scope.redirectToHomeWhenAccessIsNotGranted();
        $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
        {
            if (newValue)// && !$scope.ad.view.currentCategoryView)
            {
                var category = ProductCategoryData.getById( $scope.dd.currentCategoryId);
                if (category)
                {
                    $scope.ad.msgErrorCategory = "";
                    $scope.setCurrentProductCategoryView($scope.ad.view.productCategoryRootView.getCategoryView(category),false);
                }
                else
                {
                    $scope.ad.msgErrorCategory = "Nous sommes désolés mais cette catégorie n'existe plus ou n'est plus réservable.";
                }
            }
        });

    }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteProductCategoryCtrl.js